// JsFromRoutes CacheKey e252969a390ac9122ccf22f151456961
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/broker/signup'),
  create: /* #__PURE__ */ definePathHelper('post', '/broker/signup'),
}
